function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8 22l-.707-.707A1 1 0 007 22h1zm0 4H7a1 1 0 001 1v-1zm4 0v1a1 1 0 00.707-.293L12 26zm14-14l.707.707a1 1 0 000-1.414L26 12zm-4-4l.707-.707a1 1 0 00-1.414 0L22 8zm-1.293 2.293a1 1 0 10-1.414 1.414l1.414-1.414zm1.586 4.414a1 1 0 001.414-1.414l-1.414 1.414zM7 22v4h2v-4H7zm1 5h4v-2H8v2zm4.707-.293l14-14-1.414-1.414-14 14 1.414 1.414zm14-15.414l-4-4-1.414 1.414 4 4 1.414-1.414zm-5.414-4l-14 14 1.414 1.414 14-14-1.414-1.414zm-2 4.414l3 3 1.414-1.414-3-3-1.414 1.414z",
  fill: "#9CA6B0"
});
function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    fill: "none"
  }, props), _ref);
}
export default SvgPencil;